import { PageContentFavorites } from '@restaurant/core'
import { useWebFavoritesPageViewModel } from '../viewmodels/pages/WebFavoritesPageViewModel'

export default function FavoritesPage() {
  const viewModel = useWebFavoritesPageViewModel()
  const pageProps = viewModel.getPageContentFavoritesProps()

  return (
    <PageContentFavorites
      {...pageProps}
      testID="favorites-page"
      accessibilityLabel="Your favorite items"
    />
  )
}
